import { CategoryResponse, GetProductPagedResponse, PagedResult } from '../types';
import { commerceApiClient } from './axiosService';

export const getOrganisationCategories = async (): Promise<CategoryResponse[]> => {
  return commerceApiClient.get<CategoryResponse[]>('/categories');
};

export const getCategoryBySlug = async (slug: string): Promise<CategoryResponse | null> => {
  try {
    return await commerceApiClient.get<CategoryResponse>(`/categories/slug/${slug}`);
  } catch (error) {
    return null;
  }
};

export const getChildCategories = async (parentCategoryId: string): Promise<CategoryResponse[]> => {
  try {
    return await commerceApiClient.get<CategoryResponse[]>(`/categories/${parentCategoryId}/children`);
  } catch (error) {
    return [];
  }
};

export const getProductsByCategory = async (
  categoryId: string, 
  page: number = 1, 
  pageSize: number = 5
): Promise<PagedResult<GetProductPagedResponse>> => {
  try {
    const params = new URLSearchParams();
    params.set('category_ids', categoryId);
    params.set('current_page', page.toString());
    params.set('page_size', pageSize.toString());
    params.set('only_active', 'true');
    
    return await commerceApiClient.get<PagedResult<GetProductPagedResponse>>(`/storefront/products?${params.toString()}`);
  } catch (error) {
    throw error;
  }
};
